import { render, staticRenderFns } from "./NoOrgRegister.vue?vue&type=template&id=318c71bf"
import script from "./NoOrgRegister.vue?vue&type=script&lang=js"
export * from "./NoOrgRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports